import { ComponentStyle } from 'base/webflow/schema';

// User classnames are prefixed with this value, so they do not clash
// with app classnames
export const CLASSNAME_PREFIX = 'U_';

function formatClassname(name: string) {
  name = name.toLowerCase();
  // See https://university.webflow.com/lesson/web-styling-using-classes#special-characters-in-class-names
  name = name.replace(/[^a-zA-Z0-9\-_]+/g, '-');
  name = name.replace(/-+$/, '');
  return name;
}

export function getClassIdToNameMap(styles: readonly ComponentStyle[]) {
  return new Map(
    styles.map((n) => [n._id, CLASSNAME_PREFIX + formatClassname(n.name)]),
  );
}

export function getClassIdToStyleLessMap(styles: readonly ComponentStyle[]) {
  return new Map(styles.map((n) => [n._id, n.styleLess]));
}
